import { get, identity, intersection } from 'lodash'
import { Observable, from, iif, of } from 'rxjs'
import { filter, first, map, mergeMap, pluck, switchMap, take, tap, toArray } from 'rxjs/operators'

import { Translation, Cache } from '@skinsoft/types'
import { Proxy } from '@skinsoft/network'
import { DataStore } from '@skinsoft/data-store'

// @ts-ignore
export class TranslationDataStore extends DataStore<Translation> {
    public static getInstance() {
        if (!TranslationDataStore.instance) {
            TranslationDataStore.instance = new TranslationDataStore();
        }

        return TranslationDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$translationDataStore = TranslationDataStore.getInstance();
    }

    private static instance: TranslationDataStore = null as any;

    constructor(proxy?: Proxy, cache?: Cache<Translation>) {
        super('/translations', undefined, undefined, undefined, proxy, cache);
    }

    public fetchOne(id: string, networkFirst = false) {
        return super.fetchOne(id, false).pipe(
            tap(translation => {
                this.cache.write(`/translations/${id}`, [translation])
            })
        )
    }

    public getMessage(key: string, locale: string): Observable<string> {
        return this.cache.read(`/translations/${locale}`)
            .pipe(
                map(
                    translations => {
                        if (translations && translations[0]) {
                            return get(translations[0].message, key);
                        }
                        return key;
                    }
                )
            );
    }

    public getAllAvailableLanguages(languageList: string[] = []): Observable<string[]> {
        return this.proxy.fetch('/languages').pipe(
            pluck('_embedded', 'languages'),
            map(languages => languages.map(language => language.languageKey)),
            map(appLanguages => iif(() => languageList.length === 0, of(appLanguages), of(intersection(appLanguages, languageList)))),
            switchMap(languages => languages),
            first(),
        )
    }

    public filterLanguageListWithCacheContent(languageList: string[]): Observable<string[]> {
        return from(languageList).pipe(
            mergeMap(key => this.cache.read(`/translations/${key}`)),
            take(languageList.length),
            map(list => list && list[0]),
            filter(identity),
            map(translation => translation?.lang || ''),
            toArray()
        )
    }

    public getDateFormat(): Observable<String> {
        return this.proxy.fetch('/languages/formatDateEnUs')
    }
}
